import { useContext } from 'react';

import { AutoSignInContext } from '@/contexts';

export const useAutoSignInContext = () => {
	const autoSignInContext = useContext(AutoSignInContext);
	return autoSignInContext;
};
